/* import __COLOCATED_TEMPLATE__ from './automated-resolution-rate.hbs'; */
/* RESPONSIBLE TEAM: team-reporting */
import { inject as service } from '@ember/service';
import { action } from '@ember/object';
import Component from '@glimmer/component';
import { units } from 'embercom/lib/reporting/flexible/formatters';
import {
  RESOLUTION_BOT_ENGAGED,
  RESOLUTION_BOT_RESOLVED,
} from 'embercom/lib/reporting/csf-queries';
import { getTimeConfig } from 'embercom/lib/reporting/csf-query-helper';
import { buildDataConfigWithComparisons } from '../../../../lib/reporting/comparison-data-config';
import { improvementDirections } from 'embercom/components/reporting/element/summary-comparison';

const AUTOMATED_RESOLUTION_RATE_NUMERATOR = 'automated-resolution-rate-numerator';
const AUTOMATED_RESOLUTION_RATE_DENOMINATOR = 'automated-resolution-rate-denominator';

export default class ArticleResolutionRate extends Component {
  @service intercomEventService;

  get viewConfig() {
    return {
      formatUnit: { unit: units.percent },
      counter: {
        [AUTOMATED_RESOLUTION_RATE_NUMERATOR]: {
          improvementDirection: improvementDirections.INCREASING,
        },
      },
    };
  }

  get time() {
    return getTimeConfig({ range: this.args.range });
  }

  get dataConfig() {
    return buildDataConfigWithComparisons(
      {
        series: [
          {
            name: AUTOMATED_RESOLUTION_RATE_NUMERATOR,
            ...RESOLUTION_BOT_RESOLVED,
            time: this.time,
          },
          {
            name: AUTOMATED_RESOLUTION_RATE_DENOMINATOR,
            ...RESOLUTION_BOT_ENGAGED,
            time: this.time,
          },
        ],
      },
      this.args.range,
    );
  }

  @action
  trackAnalyticsEvent() {
    this.intercomEventService.trackAnalyticsEvent({
      action: 'hovered',
      object: 'tooltip',
      context: 'automated_resolution_rate',
    });
  }
}
